import ShButton from '@/components/Helpers/ShButton';
import ShCard from '@/components/Helpers/ShCard';

// @vue/component
export default {
  name: 'ConnectionsUtilsPagination',

  components: {
    ShCard,
    ShButton,
  },

  data() {
    return {
      actualPage: 1,
    };
  },

  computed: {
    connectionsListIsEmpty() {
      return this.$store.getters['connections/connections'].list.length === 0;
    },
    connectionsListTotal() {
      return this.$store.getters['connections/connections'].list.total;
    },
    canGoToNextPage() {
      return this.connectionsListTotal >= this.actualPage * 25;
    },
  },

  created() {
    this.$EventBus.$on('ConnectionsUtilsPagination/SYNC_PAGE_NUMBER', (actualPage) => {
      this.actualPage = actualPage;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('ConnectionsUtilsPagination/SYNC_PAGE_NUMBER');
  },

  methods: {
    __validatePageNumber() {
      if (this.actualPage <= 0) this.actualPage = 1;
    },
    changePage(type) {
      switch (type) {
        case 'next': this.actualPage = this.actualPage + 1; break;
        case 'previous': this.actualPage = this.actualPage - 1; break;
        default: break;
      }
      this.__validatePageNumber();
      this.$store.dispatch('connections/setConnectionsDownloadParams', { filters: {}, page: this.actualPage });
      this.$EventBus.$emit('ConnectionsUtilsPagination/SYNC_PAGE_NUMBER', Number(this.actualPage));
    },
  },
};
